import { render, staticRenderFns } from "./ProjectFormDialog.vue?vue&type=template&id=22ef9364&scoped=true"
import script from "./ProjectFormDialog.vue?vue&type=script&lang=js"
export * from "./ProjectFormDialog.vue?vue&type=script&lang=js"
import style0 from "./ProjectFormDialog.vue?vue&type=style&index=0&id=22ef9364&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ef9364",
  null
  
)

export default component.exports